import React from 'react'
import Page404 from '../../src/pages/404'

//* utils
import MODULE_MAPPING from '../constants/contentIDs'
import { getTemplate } from './getPageTemplate'
import { staticData } from './getStaticData'

/**
 * Return the page markup given a data set
 * @param data page data (includes page type)
 * @returns
 */
export const pageTemplate = (data: any) => {
  const {
    announcement,
    mainNavBanner,
    featuredSlider,
    header,
    minHeader,
    footer,
    browserLanguage,
  } = staticData(data)

  const minHeaderTypes = [
    MODULE_MAPPING.PAGE_ANALYST_REPORT,
    MODULE_MAPPING.PAGE_WHITEPAPER,
    MODULE_MAPPING.PAGE_PLACEHOLDER,
    MODULE_MAPPING.PAGE_DOWNLOAD,
    MODULE_MAPPING.PAGE_EVENTS,
  ]

  const contentType = data.pageData.contentType
  const Template = getTemplate(contentType)

  const props =
    contentType !== MODULE_MAPPING.PAGE_PDF
      ? {
          footerData: footer,
          headerData: minHeaderTypes.includes(contentType) ? minHeader : header,
          announcementData: announcement,
          mainNavBannerData: mainNavBanner,
          browserLanguageData: browserLanguage,
          featuredSliderData: featuredSlider,
        }
      : {}

  if (Template) {
    return <Template {...data.pageData.pageData} {...props} />
  } else {
    console.log(`Template not found: ${data.status}`)
    return (
      <Page404
        // @ts-ignore
        headerData={header?.allContentfulNavMenu?.nodes[0]}
        footerData={footer?.allContentfulNavMenu?.nodes[0]}
        announcementData={announcement}
        browserLanguageData={browserLanguage}
        lang={data.locale}
      />
    )
  }
}
